import type { DamageOnlyResponse, HazardPlusTotal, Year } from "../../schema";

export const getDamageFromResponse = ({
  response,
  hazard,
  year,
}: {
  response: DamageOnlyResponse;
  hazard: HazardPlusTotal;
  year: Year;
}): number | null => {
  const scenario = response.result.results.rcp85;
  if (!scenario) return null;
  const { damage } = scenario;
  const damageForHazard = hazard === "total" ? damage.total : damage.by_hazard[hazard];
  return damageForHazard[year] ?? null;
};
